<template>
  <div class="content">
    <h2>隐私政策</h2>
    <div class="main" v-html="text"></div>
  </div>
</template>
<script>
import {
  getContentInfo, //内容
} from "@/api/index.js";
export default {
  name: "Privacypolicy",
  data() {
    return {
      text: "",
    };
  },
  mounted() {
    this.Privacypolicy();
  },
  methods: {
    // 隐私政策
    async Privacypolicy() {
      let res = await getContentInfo({ contentType: 6, type: 3 });
      console.log(res);
      if (res.code == 1) {
        let resData = res.data || {};
        this.text = resData.content || "";
        // this.contentImg = resData.articleImage
        //   ? "/com/file/fileDownLoad?filePath=" + resData.articleImage
        //   : "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
}
.main {
  line-height: 2;
}
h2 {
  margin-top: 30px;

  text-align: center;
}
</style>